import React from 'react';
import BaseRowView from '../..';
import "./styles.css";

/**
 * @function StatementView
 * @param {STRING} date - The date of the statement is passed through to the mainText of the BaseRowView.
 * @param {STRING} className - Additional classes to add to the StatementView.
 * @return {React.Component}
 * @exported true
 * @description This is a component that shows statements date. It is built off of the BaseRowView.
 * @example
 * <StatementView className="addedClass" date="XX/XX/XXXX" />
 */
export default function StatementView(props) {
  const date = props.date ?? "";
  const className = props.className ?? "";
  const dataPoint = props.dataPoint ?? "";
  
  return (
    <div className={className + " statement-view"}>
      <BaseRowView mainText={ date } onClick={props.onClick} dataPoint={ dataPoint }>View</BaseRowView>
    </div>
  );
}